const CountiesInKenya = [
  "Baringo",
  "Bomet",
  "Bungoma",
  "Busia",
  "Embu",
  "Garissa",
  "Homa Bay",
  "Isiolo",
  "Kajiado",
  "Kakamega",
  "Kericho",
  "Kiambu",
  "Kirinyaga",
  "Kisii",
  "Kilifi",
  "Kisumu",
  "Kitui",
  "Kwale",
  "Laikipia",
  "Lamu",
  "Machakos",
  "Makueni",
  "Mandera",
  "Maragua",
  "Meru",
  "Migori",
  "Mombasa",
  "Murang'a",
  "Nairobi City",
  "Nakuru",
  "Nandi",
  "Narok",
  "Nyeri",
  "Nyandarua",
  "Nyamira",
  "Siaya",
  "Taita Taveta",
  "Tana River",
  "Tharaka-Nithi",
  "Trans Nzoia",
  "Uasin Gishu",
  "Vihiga",
  "Wajir",
  "West Pokot",
  "Wajir East",
  "Marsabit",
  "Samburu",
  "Turkana",
];

export default CountiesInKenya;
